import React from 'react';
import Slider from 'rc-slider';

export default class CmsElementCol extends React.Component {
  render() {
    const {
      intl: { messages },
      getParamValue,
      setParam,
      navigateBack,
    } = this.props;

    const xs = parseInt(getParamValue('xs', '12'), 10);
    const sm = parseInt(getParamValue('sm', xs), 10);
    const md = parseInt(getParamValue('md', sm), 10);
    const lg = parseInt(getParamValue('lg', md), 10);

    const xsOffset = parseInt(getParamValue('xsOffset', '0'), 10);
    const smOffset = parseInt(getParamValue('smOffset', '0'), 10);
    const mdOffset = parseInt(getParamValue('mdOffset', '0'), 10);
    const lgOffset = parseInt(getParamValue('lgOffset', '0'), 10);

    return (
      <>
        <div className="m-b-20">
          <a
            href="#back"
            className="m-r-15 bg-master-light fs-14 p-l-15 p-r-15 p-t-5 p-b-5 text-master b-rad-lg"
            onClick={navigateBack}
          >
            <i className="fa fa-angle-left m-r-5" /> {messages.back}
          </a>

          <b>{messages.cms_col}</b>
        </div>

        <div className="form-group-attached">
          <p>Width</p>
          <div className="form-group form-group-default">
            <label>XS: {xs}</label>
            <Slider value={xs} min={1} max={12} step={1} onChange={value => setParam('xs', value)} />
          </div>
          <div className="form-group form-group-default">
            <label>SM: {sm}</label>
            <Slider value={sm} min={1} max={12} step={1} onChange={value => setParam('sm', value)} />
          </div>
          <div className="form-group form-group-default">
            <label>MD: {md}</label>
            <Slider value={md} min={1} max={12} step={1} onChange={value => setParam('md', value)} />
          </div>
          <div className="form-group form-group-default">
            <label>LG: {lg}</label>
            <Slider value={lg} min={1} max={12} step={1} onChange={value => setParam('lg', value)} />
          </div>
        </div>

        <div className="m-t-15">
          <p>Offset</p>
          <div className="form-group form-group-default">
            <label>XS: {xsOffset}</label>
            <Slider value={xsOffset} min={0} max={12} step={1} onChange={value => setParam('xsOffset', value)} />
          </div>
          <div className="form-group form-group-default">
            <label>SM: {smOffset}</label>
            <Slider value={smOffset} min={0} max={12} step={1} onChange={value => setParam('smOffset', value)} />
          </div>
          <div className="form-group form-group-default">
            <label>MD: {mdOffset}</label>
            <Slider value={mdOffset} min={0} max={12} step={1} onChange={value => setParam('mdOffset', value)} />
          </div>
          <div className="form-group form-group-default">
            <label>LG: {lgOffset}</label>
            <Slider value={lgOffset} min={0} max={12} step={1} onChange={value => setParam('lgOffset', value)} />
          </div>
        </div>
      </>
    );
  }
}
